export { default as ProductsIndexPageCategoriesNavBody } from './ProductsIndexPageCategoriesNavBody';
